<template>
    <div class="menu-button-container">
        <button class="draggable-item-menu-btn draggable-item-menu-btn-green draggable-item-menu-btn-delete" @click="openModal">
            Eliminar
        </button>
        <transition name="slide-fade">
            <DeleteStockOrderReferenceButtonActionModal
                v-if="showModal"
                :closeModal="closeModal"
                :orderReferenceId="orderReferenceId"
                :endOfAction="endOfAction"
            />
        </transition>
    </div>
</template>

<script>
import { showCustomSuccessSweetAlert, showCustomErrorSweetAlert } from '../../../../../common/utils';
import DeleteStockOrderReferenceButtonActionModal from './DeleteStockOrderReferenceButtonActionModal.vue';
export default {
    name: "DeleteStockOrderReferenceButton",
    components: {
        DeleteStockOrderReferenceButtonActionModal
    },
    data() {
        return {
            showModal: false,
        };
    },
    props: {
        orderReferenceId: {
            type: Number,
            required: true,
        },
        endOfAction: {
            type: Function,
            required: true,
        },
    },
    methods: {
        openModal() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
    },
};
</script>